import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=fbc3b280&"
import script from "./bannerList.vue?vue&type=script&lang=js&"
export * from "./bannerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports